module.exports = __webpack_public_path__ + "e0106718/img/document.e2130c6b.svg";